export { default } from './PayerDetails'
export * as S from './PayerDetails.styles'
